import './analytics.css'
import React, { useState } from 'react'
import { Grid, TextField, createSvgIcon, Button } from '@mui/material'
import axios from 'axios.js'
import { DatePicker, LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import PrintIcon from '@mui/icons-material/Print'

import { useRef } from 'react'

import enLocale from 'date-fns/locale/en-US'
import { useAnalyzerStore } from 'app/hooks/useAnalyzer'
import useAuth from 'app/hooks/useAuth'
import DownloadIcon from '@mui/icons-material/Download'

enLocale.options.weekStartsOn = 1

const XlsIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <path d="M224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM272.1 264.4L224 344l48.99 79.61C279.6 434.3 271.9 448 259.4 448h-26.43c-5.557 0-10.71-2.883-13.63-7.617L192 396l-27.31 44.38C161.8 445.1 156.6 448 151.1 448H124.6c-12.52 0-20.19-13.73-13.63-24.39L160 344L111 264.4C104.4 253.7 112.1 240 124.6 240h26.43c5.557 0 10.71 2.883 13.63 7.613L192 292l27.31-44.39C222.2 242.9 227.4 240 232.9 240h26.43C271.9 240 279.6 253.7 272.1 264.4zM256 0v128h128L256 0z" />
    </svg>,
    'XLSX'
)

const AnalyzerToolbar = ({ onPrint, disableExcel }) => {
    const { start_date, end_date, setStartDate, setEndDate } =
        useAnalyzerStore()
    const { selectedSystem } = useAuth()
    const downloadReportFile = (sys, st, end) => {
        // throw new Error("uncomment this line to mock failure of API");
        let downloadUrl = '/api/systems/' + sys + '/report/' + st + '/' + end
        console.log('Downloading')
        return axios.get(downloadUrl, {
            responseType: 'blob',
        })
    }
    const preDownloading = () => {}
    const postDownloading = () => {}
    const onErrorDownloadFile = () => {
        console.log('Error DL')
    }

    const [url, setFileUrl] = useState(null)
    const [name, setFileName] = useState(null)
    const refdl = useRef()
    const onExportClicked = async (sys, st, end) => {
        try {
            preDownloading()
            const { data } = await downloadReportFile(sys, st, end)
            const url = URL.createObjectURL(new Blob([data]))
            setFileUrl(url)
            setFileName('report.xlsx')
            refdl.current?.click()
            postDownloading()
            URL.revokeObjectURL(url)
        } catch (error) {
            console.error(error)
            onErrorDownloadFile()
        }
    }
    return (
        <div className="print-area-none">
            <Grid
                container
                spacing={2}
                alignContent="center"
                alignItems="center"
                justifyContent="start"
            >
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={enLocale}
                >
                    <Grid item xs={4}>
                        <DatePicker
                            onChange={(newValue) => setStartDate(newValue)}
                            value={start_date}
                            inputFormat="dd/MM/yyyy"
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    id="mui-pickers-date"
                                    label="จาก:"
                                    sx={{ mb: 1, width: '100%' }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <DatePicker
                            value={end_date}
                            inputFormat="dd/MM/yyyy"
                            onChange={(newValue) => setEndDate(newValue)}
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    id="mui-pickers-date"
                                    label="ถึง:"
                                    sx={{ mb: 1, width: '100%' }}
                                />
                            )}
                        />
                    </Grid>
                    {!disableExcel && (
                        <>
                            <Button
                                startIcon={<XlsIcon color="success" />}
                                onClick={() => {
                                    onExportClicked(
                                        selectedSystem.system_id,
                                        Math.round(start_date.getTime() / 1000),
                                        Math.round(end_date.getTime() / 1000)
                                    )
                                }}
                            >
                                ดาวน์โหลดผลการตรวจทั้งหมด
                            </Button>
                            <Button
                                startIcon={<DownloadIcon />}
                                onClick={() => {
                                    onExportClicked(
                                        selectedSystem.system_id,
                                        Math.round(start_date.getTime() / 1000),
                                        Math.round(end_date.getTime() / 1000)
                                    )
                                }}
                            >
                                ดาวน์โหลดผลการตรวจ
                            </Button>
                        </>
                    )}
                    {/* TODO: jusbeetween  */}
                    {onPrint && (
                        <Button
                            startIcon={<PrintIcon />}
                            disabled={!onPrint}
                            onClick={() => {
                                onPrint?.()
                            }}
                        >
                            พิมพ์รายงานหน้านี้
                        </Button>
                    )}
                </LocalizationProvider>
            </Grid>
            <a href={url} download={name} className="hidden" ref={refdl} />
        </div>
    )
}

export default AnalyzerToolbar
